<template>
  <div class="word-wrap">
    <div id="wordView" v-html="wordText" />
  </div>
</template>

<script>
// docx文档预览(只能转换.docx文档，转换过程中复杂样式被忽，居中、首行缩进等)
import mammoth from "mammoth";
import pagePathMixin from '@/utils/page-path-mixin'
export default {
  mixins: [pagePathMixin],
  props: {
    wordURL: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      wordText: "",
      url: "",
    };
  },
  created() {
    this.url = this.wordURL || this.$route.query.wordURL
    this.getWordText();
  },
  methods: {
    getWordText() {
      const xhr = new XMLHttpRequest();
      xhr.open("get", this.url, true);
      xhr.responseType = "arraybuffer";
      xhr.onload = () => {
        if (xhr.status == 200) {
          mammoth.convertToHtml({ arrayBuffer: new Uint8Array(xhr.response) }).then((resultObject) => {
            this.$nextTick(() => {
              this.wordText = resultObject.value;
            });
          });
        }
      };
      xhr.send();
    }
  },
};
</script>

<style>
.word-wrap {
  padding: 1% 15%;
  background: #fff;
}
img {
  width: 100%;
}
</style>
